import modules from "../../../web-sh/src/store/reducers/modules/index";
import auth from "./auth";
import payment from "./payment";
import resource from "./resource";
import onboarding from "./onboarding";
import enterprise from "./enterprise";
import privateEmail from "./private-email";
import permission from "./permission";

export default {
  ...modules,
  auth,
  payment,
  resource,
  onboarding,
  enterprise,
  privateEmail,
  permission
}